<template>
  <v-menu
    offset-y
    left
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="disabled"
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>{{ show ? '' : 'mdi-dots-vertical' }}</v-icon>
      </v-btn>
    </template>
    <v-list
      dense
      class="pt-0 pb-0"
    >
      <v-list-item
        v-for="(action, i) in actions"
        :key="i"
      >
        <v-list-item-title>
          <span
            class="d-flex align-center caption"
            style="cursor: pointer;"
            @click="$emit(action.method)"
          >
            <v-icon
              class="mr-2"
              size="20"
            >{{ action.icon }}</v-icon>
            {{ action.title }}
          </span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: ["actions", "disabled", "show"],
};
</script>